<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">Ověření emailové adresy</div>
    </div>

    <div class="hypo-dialog-content" [attr.data-testid]="'verify-email-dialog'">
        @if (usersService.user.contact?.emailVerified) {
            <div class="hypo-dialog-content">
                <p>Děkujeme. Vaše emailová adresa byla úspěšně ověřena.</p>
            </div>
            <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-center">
                <button
                    (click)="dialogRef.close()"
                    class="btn btn-lg orange info-text-dialog-button"
                    [attr.data-testid]="'verify-email-dialog-button-ok'"
                    mat-button
                    type="button">
                    OK
                </button>
            </div>
        }

        @if (!usersService.user.contact?.emailVerified) {
            <div class="hypo-dialog-content">
                <p>Na vaši adresu byl odeslán email s ověřovacím kódem.</p>
                <div class="input-label">Zadejte ověřovací kód</div>
                <div class="form-row">
                    <mat-form-field floatLabel="always">
                        <input matInput autocapitalize="off" [(ngModel)]="code" />
                    </mat-form-field>
                </div>
            </div>
            <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-around">
                <button
                    type="button"
                    mat-button
                    color="warn"
                    [attr.data-testid]="'verify-email-dialog-button-cancel'"
                    (click)="close()">
                    Zrušit
                </button>
                <button
                    type="button"
                    mat-raised-button
                    color="primary"
                    [attr.data-testid]="'verify-email-dialog-button-ok'"
                    (click)="verify()"
                    [disabled]="!code">
                    Potvrdit
                </button>
            </div>
        }
    </div>
</mat-dialog-content>
